// extracted by mini-css-extract-plugin
export var container = "menu-overlay-module--container--rq6xQ";
export var logo = "menu-overlay-module--logo--WKqN4";
export var toggle = "menu-overlay-module--toggle--ZVVir";
export var toggleIcon = "menu-overlay-module--toggle-icon--k+EvU";
export var wrapper = "menu-overlay-module--wrapper--qQBbG";